import React from "react";
import ConsentFormBase from "./ConsentFormBase";
import PrintAdmissionConsent from "../patient/print/PrintAdmissionConsent";
import { ConsentTemplateType, FormGroupName } from "../../shared/constants";
 
const AdmissionConsentForm = (props) => (
  <ConsentFormBase
    {...props}
    groupname={FormGroupName.Admission_Consent_Form}
    templateType={ConsentTemplateType.Admission_Consent_Form}
    // subgroup="admission_consent" 
    formTitle="Admission Consent Form"
    // Investigation confirmed the existing Admission PDF does NOT include
    // IP No / Ward / Diagnosis (unlike Surgery Consent) — keeping that behavior.
    includeWardAndDiagnosis={false}
    PrintComponent={PrintAdmissionConsent}
  /> 
);

export default AdmissionConsentForm;
